module.exports = __webpack_public_path__ + "static/media/report_11-15_mobile.76326866.png";